/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Seo_DescriptionInputs */

const vi_shop_seo_description = /** @type {(inputs: Shop_Seo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả SEO`)
};

/**

* @param {Shop_Seo_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_seo_description = /** @type {((inputs?: Shop_Seo_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Seo_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_seo_description(inputs)
});